/** Public site origin for canonical URLs (no trailing slash). Set in Vercel: VITE_SITE_URL */
export function getSiteOrigin(): string {
  const raw = import.meta.env.VITE_SITE_URL?.trim()
  if (raw) {
    return raw.replace(/\/$/, '')
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin
  }
  return ''
}

export function pageUrl(path: string): string {
  const base = getSiteOrigin()
  const p = path.startsWith('/') ? path : `/${path}`
  return base ? `${base}${p}` : p
}
